import * as Sentry from '@sentry/react'

import {
  RETURN_PORTAL_STATUS_BADGE_COLOR_MAP,
  RETURN_PORTAL_STATUS_BADGE_VARIANT_MAP,
  RETURN_PORTAL_STATUS_TRANSLATION_IDS,
  type SupportedReturnCasePortalStatuses,
  supportedReturnCasePortalStatuses,
} from 'Constants/returnPortalStatus'

const isSupportedReturnCasePortalStatusString = (
  portalStatus: string,
): portalStatus is SupportedReturnCasePortalStatuses =>
  portalStatus in supportedReturnCasePortalStatuses

export const parseToSupportedPortalStatus = (
  rawPortalStatus: string,
): SupportedReturnCasePortalStatuses => {
  const parsedPortalStatus = rawPortalStatus.toLowerCase().replaceAll('_', '-')

  if (isSupportedReturnCasePortalStatusString(parsedPortalStatus)) {
    return supportedReturnCasePortalStatuses[parsedPortalStatus]
  }

  Sentry.captureException(
    new Error(
      `Unsupported portalStatus value returned from the API: ${rawPortalStatus}`,
    ),
  )

  return supportedReturnCasePortalStatuses.processing
}

export const getReturnCasePortalStatusTranslationId = (
  portalStatus: string,
): string =>
  RETURN_PORTAL_STATUS_TRANSLATION_IDS[
    parseToSupportedPortalStatus(portalStatus)
  ]

export const getReturnCasePortalStatusBadgeColor = (portalStatus: string) =>
  RETURN_PORTAL_STATUS_BADGE_COLOR_MAP[
    parseToSupportedPortalStatus(portalStatus)
  ]

export const getReturnCasePortalStatusBadgeVariant = (portalStatus: string) =>
  RETURN_PORTAL_STATUS_BADGE_VARIANT_MAP[
    parseToSupportedPortalStatus(portalStatus)
  ]
